import { UserDto } from "./UserDto";

export class UserNotificationSetupDto {
  id: number;
  userId: number | null;
  endpoint: string;
  expirationTime: number | null;
  keysP256dh: string;
  keysAuth: string;
  isActive: boolean;
  createdOn: string;
  updatedOn: string | null;
  user: UserDto;
}
